import { AutogenModelCarriersForAssignAndDispatch, AutogenRowCarriersForAssignAndDispatch } from "./autogen/AutogenModelCarriersForAssignAndDispatch";

export class ModelCarriersForAssignAndDispatch extends AutogenModelCarriersForAssignAndDispatch<RowCarriersForAssignAndDispatch> {
	constructor() {
		super(RowCarriersForAssignAndDispatch);
	}
}

export class RowCarriersForAssignAndDispatch extends AutogenRowCarriersForAssignAndDispatch {
}